import { backgroundImageForUrl } from '@shared/utils/style/backgroundImage';
import { isPhotoTombstoned } from '@shared/utils/eventPhoto/isPhotoTombstoned';
import { animationTransition } from '@shared/utils/animationTransition';

import React from 'react';
import { addRendition } from '@shared/utils/photoRendition';
import type { AuxPhoto } from '../../../AuxFrame/AuxFrame.types';

export const CoverPhoto: React.FC<{ photo: AuxPhoto }> = ({ photo }) => {
  if (isPhotoTombstoned(photo)) return null;
  return (
    <>
      <div
        style={{
          position: 'absolute',
          pointerEvents: 'none',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          height: '100vh',
          backgroundImage: backgroundImageForUrl(addRendition({ url: photo.url, renditionSize: 'xlarge' })),
          backgroundSize: 'cover',
          backgroundPosition: `${photo.layout.alignX} ${photo.layout.alignY}`,
          backgroundRepeat: 'no-repeat',
          // The AnimatedContainer above is keyed on the photo URL, so two sections sharing an
          // image keep this layer mounted and only its focal point changes. Without a transition
          // that change snaps.
          transition: animationTransition('background-position'),
        }}
      />
    </>
  );
};

CoverPhoto.displayName = 'CoverPhoto';
